import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import localStorage from "redux-persist/lib/storage";
import userReducer from "./userSlice";
import projectReducer from "./projectSlice";

// Persisted to localStorage, not sessionStorage: the auth token itself
// (lib/storage.ts, STORAGE_KEYS.ACCESS_TOKEN) already lives in localStorage,
// so keeping the profile in sessionStorage meant it vanished on every new tab
// or browser restart while the token was still valid — forcing a login the
// AuthGuard had no real reason to require.
const userConfig = {
  key: "user",
  storage: localStorage,
};

const projectConfig = {
  key: "projects",
  storage: localStorage,
};

const userPersistedReducer = persistReducer(userConfig, userReducer);
const projectPersistedReducer = persistReducer(projectConfig, projectReducer);

export const store = configureStore({
  reducer: {
    user: userPersistedReducer,
    projects: projectPersistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  devTools: process.env.NODE_ENV === "development",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
